
import { Dispatch } from 'redux';
import AppSettingsApiClient from '../api/AppSettingsApiClient';
import { ReducerActions } from '../enums/ReducerActions';

const fetchApplicationSettingsFailed = () => ({
    type: ReducerActions.FETCH_APPLICATION_SETTINGS_FAILED
})

const fetchApplicationSettingsSucceded = (appSettings: any) => ({
    type: ReducerActions.FETCH_APPLICATION_SETTINGS_SUCCEEDED,
    appSettings
})

const fetchApplicationSettings = () => ({
    type: ReducerActions.FETCH_APPLICATION_SETTINGS_IN_PROGRESS
})

export default () => (dispatch: Dispatch<any>) => {
    return new Promise<void>(async (resolve, reject) => {
        dispatch(fetchApplicationSettings());
        
        try {
            const applicationSettings = await AppSettingsApiClient.getApplicationSettings();
            dispatch(fetchApplicationSettingsSucceded(applicationSettings));
            resolve();
        } catch {
            dispatch(fetchApplicationSettingsFailed());
            reject();
        }
    });
}
